import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./AddRemark.module.css";
import companyStore from "../../Store/Store";
import { observer } from "mobx-react";
import { jwtDecode } from "jwt-decode";
import { CognitoIdentityProviderClient, InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider";
import KeyValueClient from "../../services/KeyValueClient";
import config from "../../config/config";

const AddRemark = observer(({ isVisible, onClose, className = "" }) => {
  const [Remarks, setRemarks] = useState()
  const [errormsg, setErrorMsg] = useState({
    MaxRemarkLength: false,
    SomethingWentWrong: false,
    EmptyRemark: false,
  });


  function generateMonthlyDatesObject(year, month) {
    const datesObj = {};
    try {
      // Validate inputs
      if (!Number.isInteger(year) || year < 1900 || year > 2100) {
        throw new Error("Year must be a valid integer between 1900 and 2100");
      }
      if (!Number.isInteger(month) || month < 1 || month > 12) {
        throw new Error("Month must be an integer between 1 and 12");
      }

      // Get number of days in the month
      const lastDay = new Date(year, month, 0).getDate();

      for (let day = 1; day <= lastDay; day++) {
        const dateKey = `${year}${String(month).padStart(2, "0")}${String(day).padStart(2, "0")}`;
        datesObj[dateKey] = null; // You can change default value as needed
      }

      return datesObj;
    } catch (err) {
      console.log("error While Creating NewObj", err);
    }
  }

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
      } else {
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      navigate("/login");
    } finally {
    }
  };

  const UpdateRemark = async () => {
    setErrorMsg({
      MaxRemarkLength: false,
      SomethingWentWrong: false,
      EmptyRemark: false,
    });
    if (Remarks.trim().length == 0) {
      setErrorMsg((prev) => ({ ...prev, EmptyRemark: true }));
      return
    }
    if (!companyStore?.Remarks.year || !companyStore?.Remarks.month || !companyStore?.Remarks?.filename) {
      console.log("Values unavail");

    }
    let key = companyStore?.Remarks?.filename.split("-",)
    let newkey = key[0] + key[1] + key[2]
    let mainkey = `${companyStore.Company_Id}${companyStore?.Remarks.year}${companyStore?.Remarks.month}`

    let tokens = JSON.parse(localStorage.getItem("authToken") || "{}");
    console.log("tokens", tokens)

    const expired = isTokenExpired(tokens.IdToken);

    if (expired) {
      getNewTokens(tokens);
      return;
    }

    try {
      const client = new KeyValueClient(
        config.keystore_endpoint, // ← MUST be Envoy proxy, not 8080
        {
          cognitoToken: tokens.IdToken,
        },
      );
      const data = await client.get(mainkey);
      let parsed_data
      let parsed_value
      if (data) {
        parsed_data = JSON.parse(data)
        if (parsed_data.value) {
          parsed_value = JSON.parse(parsed_data?.value)
        }
      }

      if (!parsed_value) {
        let values = generateMonthlyDatesObject(Number(companyStore?.Remarks.year), Number(companyStore?.Remarks.month))
        parsed_value = values
      }
      parsed_value[newkey] = Remarks
      let setResult = await client.add(mainkey, JSON.stringify(parsed_value))
      console.log("setResult", setResult);
      if (!setResult.message == "Add Successful") {
        setErrorMsg((prev) => ({ ...prev, SomethingWentWrong: true }));
      }
      onClose()
    } catch (err) {
      console.log("error", err);
      setErrorMsg((prev) => ({ ...prev, SomethingWentWrong: true }));

    }
    // mock Api to Set new Remark 

  }

  useEffect(() => {
    if (isVisible) {
      const currentRemark = companyStore?.Remarks?.remark ?? "";
      console.log("🔄 Syncing remark:", currentRemark, "from", companyStore?.Remarks);
      setRemarks(currentRemark);
    } else {
      // Optional: Reset when modal closes
      setRemarks("");
    }
  }, [isVisible, companyStore?.Remarks?.remark]);

  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={styles.containerNotifi}>
        {/* Header */}
        <div className={styles.ContainerHeader}>
          <div className={styles.ContainerHeadings}>
            <div className={styles.ContainerMainHeading}>Add Remarks</div>
            <div className={styles.ContainerSubHeading}>
              <span className={styles.ContainerSubHighlightedHeading}>
                File:
              </span>
              {companyStore?.Remarks?.filename}
            </div>
          </div>
          <div onClick={() => { onClose() }}>
            <img className={styles.filterLinesIcon} alt="" src="/x-close.svg" />
          </div>
        </div>

        {/* Content */}
        <div className={styles.containerContent}>
          <div className={styles.ContentHeading}>Remarks</div>
          <input
            rows={5}
            value={Remarks}
            onChange={(e) => {
              setErrorMsg({
                MaxRemarkLength: false,
                SomethingWentWrong: false,
                EmptyRemark: false,
              });
              const cleaned = e.target.value.replace(
                /[\p{Extended_Pictographic}\p{Emoji_Presentation}\p{Emoji}\uFE0F]/gu,
                ""
              );
              if (e.target.value.length < 201) { setRemarks(cleaned) }

              if (e.target.value.length >= 201) {
                setErrorMsg((prev) => ({ ...prev, MaxRemarkLength: true }));
              }
            }}
            placeholder="Enter remarks here..."
            className={styles.ContentinputFiled}
          />
          {errormsg.MaxRemarkLength && <div className={styles.ContainerSubHeading, styles.ContainerSubHighlightedHeading2}>200 Character limit exceeded.</div>}
          {errormsg.SomethingWentWrong && <div className={styles.ContainerSubHeading, styles.ContainerSubHighlightedHeading2}>Failed to save remark. Please try again</div>}
          {errormsg.EmptyRemark && <div className={styles.ContainerSubHeading, styles.ContainerSubHighlightedHeading2}>Please add remarks before saving</div>}
        </div>

        {/* Submit */}
        <div className={styles.ContentActions}>
          <div className={styles.ContentActionbutton} onClick={() => { onClose() }}>Cancel</div>
          <div className={styles.ContentActionbuttoninverted} onClick={() => { UpdateRemark() }}>Save Remark</div>
        </div>
      </div>
    </div>
  );
});

AddRemark.propTypes = {
  className: PropTypes.string,
};

export default AddRemark;
